// J-244 (the owner's order of 2026-10-16, item 3): an account created by an admin, or whose password an
// admin reset, must change its password before anything else. The server refuses every other API call
// with 403 `password_change_required`; the app sends the user to the change-password page instead.

/** True when the session says the account must change its password first. */
export function mustChangePassword(session: {
  user: { mustChangePassword?: boolean | null | undefined };
}): boolean {
  return session.user.mustChangePassword === true;
}

/** Better Auth's refusal of a change, in words. Never repeats a password. */
export function changePasswordMessage(error: {
  status?: number | undefined;
  code?: string | undefined;
  message?: string | undefined;
}): string {
  if (error.status === 429)
    return "Too many attempts from this network. Wait a minute, then try again.";
  switch (error.code) {
    case "INVALID_PASSWORD":
      return "The current password is incorrect.";
    case "PASSWORD_TOO_SHORT":
      return "Use at least 15 characters.";
    case "PASSWORD_TOO_LONG":
      return "Use at most 128 characters.";
    case "PASSWORD_UNCHANGED":
      return "Choose a new password that is different from the current one.";
    case "PASSWORD_COMPROMISED":
      return "This password appears in a known data breach. Choose a different one.";
    default:
      return error.message ?? "The password was not changed. Try again.";
  }
}
